import { getTypographyStyles } from "./utils";
export const ThemedHeading = {
    baseStyle: {},
    sizes: {},
    variants: {
        'display.l': getTypographyStyles('display.l'),
        'display.m': getTypographyStyles('display.m'),
        'display.s': getTypographyStyles('display.s'),
        'heading.xl': getTypographyStyles('heading.xl'),
        'heading.l': getTypographyStyles('heading.l'),
        'heading.m': getTypographyStyles('heading.m'),
        'heading.s': getTypographyStyles('heading.s'),
        'heading.xs': getTypographyStyles('heading.xs'),
        'heading.brand': getTypographyStyles('heading.brand')
    },
    defaultProps: {
        variants: 'heading.m'
    }
};

//# sourceMappingURL=Heading.js.map